import { Button, Stack, TextField } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import GroupAdd from "@mui/icons-material/GroupAdd";
import Badge from "@mui/material/Badge";
import {
  Grouping,
  AggregatedTradeData,
  AggregatedDepositData,
  AggregatedWithdrawalData,
} from "../types";
import { useState } from "react";

interface TableControlsProps<T> {
  filtersLength: number | null;
  openFilter: () => void;
  groupings: Grouping[];
  addGrouping: () => void;
  handleDownloadCSV: () => void;
  isLoading: boolean;
  isFetching: boolean;
  data:
    | AggregatedTradeData[]
    | AggregatedDepositData[]
    | AggregatedWithdrawalData[];
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
}

const TableControls = <T,>({
  filtersLength,
  openFilter,
  groupings,
  addGrouping,
  handleDownloadCSV,
  isFetching,
  isLoading,
  data,
  limit,
  setLimit,
}: TableControlsProps<T>) => {
  const [localLimit, setLocalLimit] = useState(limit);
  return (
    <Stack direction={"row"} sx={{ justifyContent: "space-between", mb: 2 }}>
      <Stack direction="row" spacing={1}>
        <TextField
          variant="standard"
          size="medium"
          type="number"
          label="Limit"
          value={localLimit}
          defaultValue={100}
          onChange={(event) =>
            setLocalLimit(Number.parseInt(event.target.value))
          }
          onBlur={(_event) => setLimit(localLimit)}
          onWheel={(event) => (event.target as HTMLInputElement).blur()}
        />
        <Button
          variant="outlined"
          startIcon={
            <Badge badgeContent={filtersLength} color="primary">
              <FilterListRoundedIcon color="primary" />
            </Badge>
          }
          onClick={openFilter}
          style={{ height: "5.1vh" }}
        >
          Filter
        </Button>
        {groupings.length === 0 ? (
          <Button
            variant="outlined"
            startIcon={<GroupAdd color="primary" />}
            onClick={addGrouping}
            style={{ height: "5.1vh" }}
          >
            Add Grouping
          </Button>
        ) : null}
      </Stack>
      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        onClick={handleDownloadCSV}
        disabled={!data.length || isLoading || isFetching}
        style={{ height: "5.1vh" }}
      >
        Download CSV
      </Button>
    </Stack>
  );
};

export default TableControls;
